var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { IconButton, Menu, MenuItem } from "@mui/material";
import { GridMoreVertIcon } from "@mui/x-data-grid";
import React from "react";
import { useRecordContext } from "react-admin";
import { makeStyles } from "@mui/styles";
var useStyles = makeStyles({
    menu: {
        width: "max-content",
    },
});
export var ListActionsMenu = function (props) {
    var record = useRecordContext();
    var actions = props.actions;
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var classes = useStyles();
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var filteredActions = actions.filter(function (action) { return !action.showAction || action.showAction(record.id); });
    var handleClickAction = function (action) {
        action.action(record.id);
        if (action.saveRecordAction) {
            action.saveRecordAction(record);
        }
        handleClose();
    };
    return (_jsxs("div", { children: [_jsx(IconButton, __assign({ id: "actions-menu-button", "aria-controls": open ? "actions-menu" : undefined, "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, onClick: handleClick }, { children: _jsx(GridMoreVertIcon, {}) })), _jsx(Menu, __assign({ classes: { paper: classes.menu }, id: "actions-menu", "aria-labelledby": "actions-menu-button", anchorEl: anchorEl, open: open, onClose: handleClose, anchorOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                } }, { children: filteredActions && filteredActions.length > 0
                    ? filteredActions.map(function (action, index) {
                        var _a;
                        return (_jsxs(MenuItem, __assign({ onClick: function () { return handleClickAction(action); }, sx: { display: "flex", gap: "8px" }, className: (_a = action.className) !== null && _a !== void 0 ? _a : "" }, { children: [action.icon, action.label || ""] }), index));
                    })
                    : null }))] }));
};
